// old 2022 db values had statusOPBook as boolean
// export const OPBookLabelBool = (bool) => {
//   if (bool) return 'Yes';
//   return 'No';
// }

export const OPBookLabel = (string) => {
	if (!string) return 'N/A';
}